import React, { SVGProps } from "react";
export const ClockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 128 128"
    {...props}
  >
    <g fill="#563428">
      <path d="M5.65 113.36v3.52c0 1.66 1.34 3 3 3h18.49c1.66 0 3-1.34 3-3v-3.52H5.65zM98.86 113.36v3.52c0 1.66 1.34 3 3 3h18.49c1.66 0 3-1.34 3-3v-3.52H98.86z" />
    </g>
    <path
      fill="#8b5738"
      d="M124.27 96.21c-1.26-6.22-5.51-9.3-6.53-10.36-4.8-4.98-9.98-7.13-9.98-27 0-24.21-19.58-43.83-43.76-43.93-24.18.1-43.76 19.72-43.76 43.93 0 19.87-5.18 22.03-9.98 27C9.24 86.91 5 89.99 3.73 96.21c-1.26 6.22-.5 18.28-.5 18.28h121.54s.77-12.06-.5-18.28z"
    />
    <ellipse
      cx={63.94}
      cy={60.93}
      fill="#563428"
      rx={37.5}
      ry={35.92}
      transform="rotate(-3.216 63.946 60.929)"
    />
    <circle cx={64.77} cy={59.2} r={33.42} fill="#fcebcd" />
    <circle
      cx={64.18}
      cy={58.85}
      r={33.42}
      fill="none"
      stroke="#e2a610"
      strokeMiterlimit={10}
      strokeWidth={3.932}
    />
    <path
      fill="none"
      stroke="#ffe36c"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.966}
      d="M33.5 45.57c2.44-6.26 8.71-13.58 16.44-16.97"
    />
    <path
      fill="#ba793e"
      d="M24.08 46.49c2.46-9.38 11.27-21.68 24.04-26.59.86-.33 1.77.48 1.47 1.36-1.2 3.47-3.4 4.36-4.11 4.75-7.78 4.33-13.41 11.75-16.15 17.83-.19.41-.94 2.88-3.79 4.03-1.2.48-1.7-.47-1.46-1.38zM3.01 105.98h120.87v3.47H3.01z"
    />
    <path
      fill="#563428"
      d="M112.17 80.11a23.89 23.89 0 0 1-2.44-5.08c-.57-1.69-.96-3.43-1.24-5.19-.34-2.15-.88-4.73-.65-6.9-1.54 14.37-9.98 26.67-21.97 33.49-.42.24-.63.73-.5 1.2.16.59.8.93 1.38.72 4.31-1.53 8.45-3.52 12.29-5.99 3.73-2.4 6.7-5.82 10.73-7.69 1.62-.75 3.41-1.24 5.2-1.13-1.04-.97-1.98-2.15-2.8-3.43zM17.97 75.7s1.88-6.95 2.12-12.75c1.54 14.37 9.98 26.67 21.97 33.49.42.24.63.73.5 1.2-.16.59-.8.93-1.38.72-10.74-3.81-21.12-13.47-23.21-22.66z"
    />
    <g
      fill="none"
      stroke="#3e2723"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.966}
      opacity={0.5}
    >
      <path d="m50.06 34.41 2.64 4.58M75.66 78.74l2.64 4.58M39.72 44.74l4.58 2.65M84.06 70.34l4.58 2.64M78.3 34.41l-2.64 4.58M52.7 78.74l-2.64 4.58M88.64 44.74l-4.58 2.65M44.3 70.34l-4.58 2.64M92.42 58.86h-5.28M41.23 58.86h-5.29M64.18 30.63v5.28M64.18 81.82v5.28" />
    </g>
    <path
      fill="#ba793e"
      d="M20.34 87.9c.28 1.04.35 2.16-.01 3.17-.58 1.63-2.14 2.66-3.48 3.75-1.6 1.3-3 2.84-4.14 4.56-.52.79-1 1.62-1.68 2.29-.68.66-1.6 1.15-2.54 1.04-1.2-.14-2.11-1.24-2.38-2.41-.27-1.17-.02-2.41.32-3.56 1.11-3.74 3.23-7.15 6.03-9.85 1.06-1.02 3.02-3.14 4.61-3.09 1.81.05 2.88 2.65 3.27 4.1z"
    />
    <circle cx={64.18} cy={58.86} r={3.12} fill="#3e2723" />
    <g fill="#3e2723">
      <path d="M83.27 47.77a.538.538 0 0 0-.51-.26c-.48.05-1.04.09-1.63.09-1.34.02-2.79-.28-3.61.25-1.32.85-1.43 2.08-1.29 2.96l-12.08 5.74.89 1.56 1.12 1.91 10.96-7.68c.69.56 1.81 1.07 3.2.36.87-.45 1.34-1.85 2.02-3 .3-.5.61-.97.89-1.36.14-.19.13-.4.04-.57z" />
      <path d="M56.02 53.02c.13-.88 0-2.08-1.3-2.92-.82-.53-2.27-.24-3.61-.25-.58-.01-1.14-.05-1.63-.09-.23-.02-.4.1-.51.26-.09.17-.1.38.03.57.28.39.6.86.89 1.36.68 1.15 1.16 2.55 2.02 3 1.37.71 2.48.21 3.18-.33l7.22 5.42 1.12-1.91.89-1.56-8.3-3.55z" />
    </g>
  </svg>
);
